import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logAudit } from "@/lib/api";

const PAGE_LABELS = {
  "/": "Home Hub", "/people": "People Directory", "/courts": "Court Resource Center",
  "/vendors": "Vendor & Expert Directory", "/practice-groups": "Practice Groups",
  "/news": "Firm News", "/matter": "Matter Lifecycle", "/billing": "Billing & Trust",
  "/ethics": "Ethics & Risk", "/it": "IT & Security", "/brief-bank": "Brief Bank",
  "/forms": "Brand & Forms", "/admin": "Administration",
};

export function DLPGuard() {
  const loc = useLocation();

  // Audit every page view
  useEffect(() => {
    const label = PAGE_LABELS[loc.pathname] || loc.pathname;
    logAudit("view_page", "page", loc.pathname, { label });
  }, [loc.pathname]);

  // Global DLP protections
  useEffect(() => {
    const blockCtx = (e) => {
      e.preventDefault();
      logAudit("blocked_action", "dlp", loc.pathname, { kind: "right_click" });
      return false;
    };
    const blockKeys = (e) => {
      const k = e.key.toLowerCase();
      const combo = (e.ctrlKey || e.metaKey);
      if (combo && ["s", "p", "u"].includes(k)) {
        e.preventDefault();
        logAudit("blocked_action", "dlp", loc.pathname, { kind: `ctrl_${k}` });
        return false;
      }
      if (k === "printscreen") {
        logAudit("blocked_action", "dlp", loc.pathname, { kind: "print_screen" });
      }
    };
    const blockCopy = (e) => {
      // Allow copy in inputs/textareas (forms), block elsewhere
      const t = e.target;
      const editable = t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable);
      if (!editable) {
        e.preventDefault();
        logAudit("blocked_action", "dlp", loc.pathname, { kind: "copy" });
      }
    };
    const blockDrag = (e) => { if (e.target.tagName === "IMG") e.preventDefault(); };

    document.addEventListener("contextmenu", blockCtx);
    document.addEventListener("keydown", blockKeys);
    document.addEventListener("copy", blockCopy);
    document.addEventListener("dragstart", blockDrag);
    return () => {
      document.removeEventListener("contextmenu", blockCtx);
      document.removeEventListener("keydown", blockKeys);
      document.removeEventListener("copy", blockCopy);
      document.removeEventListener("dragstart", blockDrag);
    };
  }, [loc.pathname]);

  return null;
}
